import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {RequestParameters} from '../../models/request-parameters/parameter.model';
import {RoleService} from '../../../parameters/roles/role.service';
import {Role} from '../../../parameters/roles/role.model';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-roles-autocomplete',
  templateUrl: './roles-autocomplete.component.html',
  styleUrls: ['./roles-autocomplete.component.scss']
})
export class RolesAutocompleteComponent implements OnInit {

  @Input('roleFormControl') roleFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Input('rolesType') rolesType: string;
  @Output() onRoleSelected: EventEmitter<Role> = new EventEmitter<Role>();

  @ViewChild('autoRoles') autoRoles: ElementRef;

  roles: Observable<any> = new Observable<any>();
  roleLoading: boolean = true;
  roleParameters: RequestParameters = new RequestParameters();

  constructor(private roleService: RoleService) {
  }

  ngOnInit() {
    this.roleParameters.searchString = this.rolesType.toUpperCase();
    this.updateRoles();
  }

  onSelectRole() {
    this.onRoleSelected.emit(this.roleFormControl.value);
  }

  displayRoles (role: Role) {
    if (role !== null) {
      return role.name;
    }
  }

  filterRoles (filterInput: string = '') {
    if (this.roleParameters.searchString !== filterInput) {
      this.roleParameters.searchString = filterInput;
      this.updateRoles();
    }
  }

  updateRoles () {
    this.roleLoading = true;
    this.roles = this.roleService.getRoles(this.roleParameters)
      .map(
        (response) => {
          this.roleLoading = false;
          return response.result.filter(
            (role) => {
              return role.name.includes(this.rolesType.toUpperCase());
            }
          );
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/roles-autocomplete/roles-autocomplete.component.ts